// Tiny inline status chip used in the encounter workspace to show whether
// the current field's autosave is idle, pending, or has errored out.
export default function SavingIndicator({ state }) {
  // state: 'idle' | 'saving' | 'saved' | 'error'
  if (state === 'saving') return <span className="text-xs text-slate-400 animate-pulse">Saving…</span>
  if (state === 'saved')  return <span className="text-xs text-emerald-600">Saved</span>
  if (state === 'error')  return <span className="text-xs text-rose-600">Save failed</span>
  return <span className="text-xs text-slate-300">Idle</span>
}
